class StateStoreBase {
  constructor() {
    this.subscribeHandlers = [];
  }
  subscribe(handler) {
    this.subscribeHandlers.push(handler);
  }
  unsubscribe(handler) {
    this.subscribeHandlers = this.subscribeHandlers.filter(
      (h) => h !== handler
    );
  }
  notifySubscribers(value) {
    const newValue = value ?? this.get();
    const handlers = [...this.subscribeHandlers];
    for (const handler of handlers) {
      handler(newValue);
    }
  }
}
export {
  StateStoreBase as default
};
//# sourceMappingURL=StateStoreBase.js.map
